import React from 'react';
import SentimentVeryDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentVeryDissatisfiedOutlined';
import { Typography } from '@mui/material';

const Error = () => {
    return (
        <div className="flex flex-col justify-center items-center
        py-12 px-4">
            <Typography variant="h4">خطای 404!</Typography>
            <Typography variant="h4">صفحه یافت نشد</Typography>
            <SentimentVeryDissatisfiedOutlinedIcon sx={{ mt: "0.5rem", fontSize: "7rem" }} />
        </div>
    );
}

export default Error;
